import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class BVDIndependenceIndicatorCriteria extends FilterCriteria {
  public override title = 'BVD Independence Indicator';
  public override type: FilterTypes = FilterTypes.BVDIndependenceIndicator;
  bvdIndependence: TreeNode[] = null;

  public override validate(): boolean {
    return this.bvdIndependence && this.bvdIndependence.length > 0;
  }

  public override toString(): string {
    return 'BvD Independence Indicator: ' + this.bvdIndependence.map((d) => d.data.name).join(', ');
  }
}
